<template>
    <div id="info_service_type">
        <div class="vx-card p-6">
            <div class="vx-row">
                <div class="vx-col md:w-1/2 w-full my-auto">
                    <h3>Thông tin nhóm dịch vụ</h3>
                </div>
            </div>

            <div class="vx-row">
                <div class="vx-col lg:w-1/4 md:w-1/2 w-full mt-4">
                    <label class="vs-input--label required">Tên nhóm dịch vụ</label>
                    <vs-input class="w-full" v-model="serviceTypeInfo.name" name="nameServiceType"
                              v-validate="'required'"></vs-input>
                    <span class="text-danger text-sm">{{ errors.first('nameServiceType') }}</span>
                </div>
                <div class="vx-col lg:w-1/4 md:w-1/2 w-full mt-4">
                    <label class="vs-input--label required">Mã nhóm dịch vụ</label>
                    <vs-input class="w-full" v-model="serviceTypeInfo.code" name="codeServiceType"
                              v-validate="'required'"></vs-input>
                    <span class="text-danger text-sm">{{ errors.first('codeServiceType') }}</span>
                </div>
                <div class="vx-col lg:w-1/2 w-full mt-4">
                    <label class="vs-input--label">Ghi chú</label>
                    <vs-textarea class="w-full" v-model="serviceTypeInfo.description" name="description"/>
                </div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full text-center">
                    <label class="vs-input--label">Banner</label>
                    <div class="flex justify-center items-center">
                        <div class="card-img flex justify-center" v-if="banner.length > 0" @click="deleteBanner"
                             @mouseover="showBtnDelete = true" @mouseout="showBtnDelete = false">
                            <img id="banner" :src="banner[0].src" alt="">
                            <div class="absolute delete" v-if="showBtnDelete" @click="deleteBanner">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="rgba(var(--vs-danger), 1)" width="32px"
                                     height="32px"
                                     viewBox="-1.7 0 20.4 20.4" class="cf-icon-svg" @click="deleteBanner">
                                    <path
                                        d="M16.417 10.283A7.917 7.917 0 1 1 8.5 2.366a7.916 7.916 0 0 1 7.917 7.917zm-6.804.01 3.032-3.033a.792.792 0 0 0-1.12-1.12L8.494 9.173 5.46 6.14a.792.792 0 0 0-1.12 1.12l3.034 3.033-3.033 3.033a.792.792 0 0 0 1.12 1.119l3.032-3.033 3.033 3.033a.792.792 0 0 0 1.12-1.12z"/>
                                </svg>
                            </div>
                        </div>
                        <div class="card-no-img" v-else @click="selectImage">
                            <div class="flex items-center justify-center h-full">
                                <svg xmlns="http://www.w3.org/2000/svg" width="40px" height="40px"
                                     viewBox="0 0 24 24"
                                     fill="none">
                                    <rect width="24" height="24" fill="white"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd"
                                          d="M13 9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9V11H9C8.44772 11 8 11.4477 8 12C8 12.5523 8.44772 13 9 13H11V15C11 15.5523 11.4477 16 12 16C12.5523 16 13 15.5523 13 15V13H15C15.5523 13 16 12.5523 16 12C16 11.4477 15.5523 11 15 11H13V9ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12Z"
                                          fill="#323232"/>
                                </svg>
                                <span>Thêm ảnh</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full text-center">
                    <label class="vs-input--label">Ảnh trước/sau</label>
                    <div class="flex justify-center">
                        <vue-upload-multiple-image class="m-auto" @upload-success="uploadImageSuccess"
                                                   @before-remove="beforeRemove" @edit-image="editImage"
                                                   :data-images="imagesBeforeAndAfter">
                        </vue-upload-multiple-image>
                    </div>
                </div>
                <div class="vx-col lg:w-1/2 md:w-1/3 sm:w-1/2 w-full">
                    <div class="table_media">
                        <vs-table stripe :data="careDocument" noDataText="Không có dữ liệu" pagination max-items="5">
                            <template slot="header">
                                <div class="vx-row w-full">
                                    <h4 class="vx-col w-1/2 mb-8">
                                        Danh sách file chăm sóc
                                    </h4>
                                    <div class="vx-col w-1/2">
                                        <vs-button class="float-right" color="primary" icon-pack="feather"
                                                   icon="icon-plus"
                                                   @click="addFile">Thêm file
                                        </vs-button>
                                    </div>
                                </div>
                            </template>
                            <template slot="thead">
                                <vs-th>
                                    STT
                                </vs-th>
                                <vs-th>
                                    Tên file
                                </vs-th>
                                <vs-th>
                                    Hành động
                                </vs-th>
                            </template>

                            <template slot-scope="{data}">
                                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                                    <vs-td :data="data[indextr].stt">
                                        {{ tr.stt }}
                                    </vs-td>

                                    <vs-td :data="data[indextr].fileName">
                                        {{ tr.fileName }}
                                    </vs-td>

                                    <vs-td>
                                        <div>
                                            <vx-tooltip text="Xóa" position="top">
                                                <feather-icon icon="TrashIcon" class="text-danger mt-4 mr-2"
                                                              svgClasses="h-5 w-5 hover:text-primary cursor-pointer"
                                                              @click="confirmDelete(tr)"/>
                                            </vx-tooltip>
                                        </div>
                                    </vs-td>
                                </vs-tr>
                            </template>
                        </vs-table>
                    </div>
                    <vs-input class="hidden" type="file" id="uploadFile" @change="uploadFile($event)"
                              multiple></vs-input>
                </div>
                <input type="file" ref="bannerInput" accept="image/*" @change="handleImageUpload"
                       class="hidden"/>
            </div>

            <div class="vx-row">
                <div class="vx-col w-full">
                    <div class="mt-4 flex flex-wrap items-center justify-end">
                        <vs-button class="ml-auto mt-2" @click="saveChanges" :disabled="!validateForm"
                                   v-if="(isUpdate && isPermissionUpdateService) || (!isUpdate && isPermissionCreateService)">
                            {{ `${isUpdate ? $t('button.update') : $t('button.create')}` }}
                        </vs-button>
                        <vs-button class="ml-4 mt-2" type="border" color="warning"
                                   @click="$router.push('/user/manage-service-type')">
                            {{ $t('button.back') }}
                        </vs-button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select';
import VueUploadMultipleImage from '../../../../components/VueUploadMultipleImage';
import authConfig from '@/../auth_config.json';
import {isAPI, isRouter} from "../../../../store/permission";
import {constAPI, constRouter} from "../../../../store/constant";

export default {

    data() {
        return {
            serviceTypeInfo: {
                name: null,
                code: null,
            },
            isUpdate: false,
            imagesBeforeAndAfter: [],
            banner: [],
            showBtnDelete: false,
            careDocument: [],
            dataDelete: {},
        }
    },

    components: {
        vSelect,
        VueUploadMultipleImage,
    },

    computed: {
        validateForm() {
            return !this.errors.any()
        },
    },

    async created() {

        if (this.$route.query.id) {
            this.isUpdate = true;
            await this.findServiceById(this.$route.query.id);
            for (const x of this.serviceTypeInfo.beforeAfterImages) {
                let data = await this.toDataURL(x.url);
                let dataImage = data.xhr.response;
                let metadata = {
                    type: 'image/jpeg'
                };
                let file = new File([dataImage], x.fileName, metadata);
                let result = {
                    name: x.fileName,
                    path: data.imgBase64,
                    highlight: 1,
                    default: this.serviceTypeInfo.fileManagers.indexOf(x) === 0,
                    file: file,
                    id: x.id,
                }
                this.imagesBeforeAndAfter.push(result);
            }
            for (const x of this.serviceTypeInfo.fileManagers) {
                let data = await this.toDataURL(x.url);
                let dataImage = data.xhr.response;
                let metadata = {
                    type: 'image/jpeg'
                };
                let file = new File([dataImage], x.name, metadata);
                file.id = x.id;
                this.banner.push(file);

                this.banner.forEach((file) => {
                    const reader = new FileReader();
                    reader.onload = function (e) {
                        file.src = e.target.result;
                    }
                    reader.readAsDataURL(file);
                });

                setTimeout(() => {
                    let image = document.getElementById('banner');
                    image.src = this.banner[0].src;
                }, 100)
            }
            for (const x of this.serviceTypeInfo.careDocuments) {
                let data = await this.toDataURL(x.url);
                let dataImage = data.xhr.response;
                let metadata = {
                    type: 'image/jpeg'
                };
                let file = new File([dataImage], x.name, metadata);
                file.id = x.id;
                file.fileName = x.name;
                file.stt = this.serviceTypeInfo.careDocuments.indexOf(x) + 1;
                this.careDocument.push(file);
            }
        }
    },

    methods: {
        async saveChanges(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;

            const formData = new FormData();
            const blob = new Blob([JSON.stringify(this.serviceTypeInfo)], {type: 'application/json'});
            formData.append('dto ', blob);
            this.banner.forEach(x => {
                if (!x.id) formData.append('files', x)
            });
            this.imagesBeforeAndAfter.forEach(x => {
                if (!x.id) formData.append('beforeAfterImages', x.file)
            });
            this.careDocument.forEach(x => {
                if (!x.id) formData.append('careDocuments', x);
            });

            let url = this.isUpdate ? '/beauty-service/update' : '/beauty-service/create';

            this.$vs.loading();

            this.$crm.post(url, formData).then(() => {
                this.$vs.loading.close();
                this.$router.push('/user/manage-service-type');
                this.$vs.notify({
                    color: 'success',
                    text: `${this.isUpdate ? 'Cập nhật' : 'Thêm'} nhóm dịch vụ thành công!`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                });
            }).catch(err => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            })
        },

        findServiceById(id) {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.get(`/beauty-service/find-by-id/${id}`).then(res => {
                    this.serviceTypeInfo = res.data;
                    this.serviceTypeInfo.fileManagerDeleteIds = [];
                    resolve()
                    this.$vs.loading.close();
                }).catch(err => {
                    reject()
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                })
            })
        },

        uploadImageSuccess(formData, index, fileList, file) {
            this.imagesBeforeAndAfter = fileList;
            this.setIsUpdateImages();
        },
        beforeRemove(index, done, fileList) {
            this.serviceTypeInfo.fileManagerDeleteIds.push(this.imagesBeforeAndAfter[index].id);
            this.imagesBeforeAndAfter = fileList
            this.setIsUpdateImages();
            done();
        },
        editImage(formData, index, fileList) {
            this.imagesBeforeAndAfter = fileList;
            this.setIsUpdateImages();
        },
        setIsUpdateImages() {
            if (this.isUpdate) {
                this.isUpdateImages = true;
            }
        },

        toDataURL(url) {
            return new Promise(resolve => {
                let xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    let reader = new FileReader();
                    reader.onloadend = function () {
                        resolve({imgBase64: reader.result, xhr: xhr});
                    }
                    reader.readAsDataURL(xhr.response);
                };
                xhr.open('GET', url);
                xhr.responseType = 'blob';
                xhr.send();
            })
        },

        isPermissionCreateService() {
            return isAPI(this, constAPI.beauty_service_create);
        },
        isPermissionUpdateService() {
            return isAPI(this, constAPI.beauty_service_update);
        },
        selectImage() {
            this.$refs.bannerInput.click();
        },
        handleImageUpload(event) {
            let imageUpload = [...event.target.files];
            imageUpload.forEach((file) => {
                const reader = new FileReader();
                reader.onload = function (e) {
                    file.src = e.target.result;
                }
                reader.readAsDataURL(file);
            });

            this.banner = imageUpload;
            setTimeout(() => {
                let image = document.getElementById('banner');
                image.src = imageUpload[0].src;
            }, 100)

            // Clear the file input
            this.$refs.bannerInput.value = null;
        },
        deleteBanner() {
            this.serviceTypeInfo.fileManagerDeleteIds.push(this.banner[0].id);
            this.banner = [];
        },
        uploadFile(data) {
            let file = [...data.target.files];
            this.careDocument = this.careDocument.concat(file);
            this.careDocument.forEach((q) => {
                if (!q.fileId) q.fileName = q.name;
                q.stt = this.careDocument.indexOf(q) + 1;
                return q;
            });
        },
        confirmDelete(data) {
            this.dataDelete = data;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: this.$t('warningMenuCustomer.titleWarning'),
                text: 'Bạn có chắc chắn muốn xóa file này không ?',
                accept: this.deleteFile,
                acceptText: "Xoá",
                cancelText: "Huỷ"
            })
        },

        deleteFile() {
            if (this.dataDelete.id) this.serviceTypeInfo.fileManagerDeleteIds.push(this.dataDelete.id);
            this.careDocument = this.careDocument.filter(t => t.stt != this.dataDelete.stt);
            this.careDocument.forEach((q) => {
                q.stt = this.careDocument.indexOf(q) + 1;
                return q;
            });
        },
        addFile() {
            document.getElementById('uploadFile').click();
        },
    }

}
</script>

<style scoped>
.required:after {
    content: " *";
    color: red;
}
</style>

<style lang="scss">
#info_service_type {
    .card-img {
        border-radius: 1rem;
        height: 100%;
        margin-left: 20px;
        cursor: pointer;

        img {
            width: 250px;
            height: 190px;
        }

        .delete {
            height: 190px;
            display: flex;
            align-items: center;
        }

        .delete:hover {
            svg {
                fill: rgba(var(--vs-danger), 1);
            }
        }
    }

    .card-no-img {
        border: dashed 1px #cccccc;
        border-radius: 1rem;
        height: 200px;
        width: 300px;
        margin-left: 20px;
        cursor: pointer;
    }

    .card-no-img:hover {
        border: dashed 1px rgba(var(--vs-primary), 1);

        span {
            color: rgba(var(--vs-primary), 1);
        }

        svg path {
            fill: rgba(var(--vs-primary), 1);
        }
    }
}
</style>
